/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Underline_Selected_EventsInputs */



/**
* | output |
* | --- |
* | "Underline selected events" |
*
* @param {Underline_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline_selected_events = /** @type {((inputs?: Underline_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Underline_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souligner les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse unterstreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottolinea gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подчеркните выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subrayar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用下划线标出选定的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントに下線を付ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को रेखांकित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sublinhe os eventos selecionados")
	return /** @type {LocalizedString} */ ("Underline selected events")
});